export default "__VITE_ASSET__KsZoMHOg__"